// LD-15706 — pure page-math for the offset pagination footer (First / Prev / Next / Last + "page N of M").
// Extracted from the DataTableFooter render so the branching (total pages, clamping a stale page, the
// first/last disabled states) is unit-testable without a DOM. `page` is 0-based; `count` is the server
// total for the current filters.
export const getPageState = (page = 0, pageSize = 250, count = 0) => {
  // Guard a bad/zero pageSize so ceil() can't divide by zero and produce Infinity/NaN.
  const size = pageSize > 0 ? pageSize : 1;
  const safeCount = Number.isFinite(count) && count > 0 ? count : 0;

  // At least one page even when empty, so the ribbon never reads "Page 1 of 0".
  const totalPages = Math.max(1, Math.ceil(safeCount / size));

  // Clamp into [0, totalPages - 1]: a stale page (e.g. after a filter change shrinks the result set)
  // must not disable both arrows or point past the end.
  const currentPage = Math.min(Math.max(Math.trunc(page) || 0, 0), totalPages - 1);
  return {
    totalPages,
    currentPage,
    isFirst: currentPage <= 0,
    isLast: currentPage >= totalPages - 1
  };
};

// Whether a navigation to `target` should fire, given the current derived state. Blocks no-ops (same page),
// out-of-range targets, and navigation while a fetch is in flight.
export const canGoToPage = (target, currentPage, totalPages, loading) => {
  return !loading && target !== currentPage && target >= 0 && target <= totalPages - 1;
};

// LD-15706 (L2) — parse + clamp a "Rows per page" input. Uses Number(), NOT parseInt(): parseInt('1e3', 10)
// is 1, so pasting "1e3" would silently commit 1 row/page; Number('1e3') is 1000. Truncates decimals and
// clamps into [1, maxPageSize]. Returns null for blank / non-numeric input so the caller reverts to the
// current size rather than committing 0.
export const parsePageSize = (raw, maxPageSize) => {
  const text = String(raw).trim();
  const parsed = Number(text);
  if (text === "" || !Number.isFinite(parsed)) {
    return null;
  }
  return Math.min(Math.max(Math.trunc(parsed), 1), maxPageSize);
};